import script from "./source.vue?vue&type=script&setup=true&lang=js"
export * from "./source.vue?vue&type=script&setup=true&lang=js"

import "./source.vue?vue&type=style&index=0&id=74bb92fc&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\刘正希\\Desktop\\知谦\\zq\\webside\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74bb92fc"]])

export default __exports__